import React, { useCallback, useEffect, useState } from "react";
import { Button, Dropdown } from "semantic-ui-react";
import { updatePromotion } from "../../../../services/PromotionCampaign/PromotionCampaign.service";
import { useMutation } from "@tanstack/react-query";
import { ultyToast } from '../../../Shared/UltyToast/UltyToast'

const STATUS_OPTIONS = [
  { key: 'DRAFT', value: 'DRAFT', text: 'Brouillon' },
  { key: 'ENABLED', value: 'ENABLED', text: 'Activé' },
  { key: 'DISABLED', value: 'DISABLED', text: 'Désactivé' },
];

export const EditablePromotionStatus = ({ readonly, promotion, onEdit }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [currentStatus, setCurrentStatus] = useState(promotion.status);

  useEffect(() => {
    setCurrentStatus(promotion.status);
  }, [promotion.status]);

  const handleChange = (e, { value }) => {
    setCurrentStatus(value);
  };



  const updatePromotionsMutation = useMutation({
    mutationFn: async (data) => {
      const result =  await updatePromotion(promotion.promotionCampaignId,promotion.id, {
        status: data
      });
      onEdit?.();
      return result;

    },
    onSuccess: () => {
      ultyToast({ type: 'success', title: 'Barcodes updated successfully' })
    }
  });

  const handleCancel = () => {
    setShowDropdown(false);
    setCurrentStatus(promotion.status || []);
  }

  const handleSave = useCallback(async() => {
    await updatePromotionsMutation.mutateAsync(currentStatus);
    setShowDropdown(false);
  }, [currentStatus, updatePromotionsMutation]);



  if (readonly || !showDropdown) {
    return (
      <span
        style={{
          borderBottom: isHovered ? '1px dotted #888' : '1px dotted transparent',
          cursor: readonly ? 'default' : 'pointer',
          paddingBottom: 2
        }}
        onMouseOver={() => !readonly && setIsHovered(true)}
        onMouseOut={() => !readonly && setIsHovered(false)}
        onClick={() => !readonly && setShowDropdown(true)}
      >
        {STATUS_OPTIONS.find(opt => opt.value === currentStatus)?.text || currentStatus}
      </span>
    );
  }

  return (
    <>
    <Button
              icon="save"
              color="teal"
              size="mini"
              loading={updatePromotionsMutation.isPending}
              onClick={handleSave}
              style={{ marginBottom: '8px' }}>
                Save
            </Button>
            <Button
              icon="save"
              basic
              size="mini"
              loading={updatePromotionsMutation.isPending}
              onClick={handleCancel}
              style={{ marginBottom: '8px' }}>
                Annuler
            </Button>
         <Dropdown
      selection
      defaultOpen
      options={STATUS_OPTIONS}
      value={currentStatus}
      onChange={handleChange}
      style={{ minWidth: 120 }}
    />
    </>
  );
};
